import { IResponse } from "../interfaces/IResponse";
import { apiService } from "./api";
import { apiValues } from "./api-values";
import { handleError } from "./error-handler";


export class AppService {
  /**
   * Upload photo
   * @param formData FormData with image file
   * @returns return server response
   */
  async uploadAsset(formData: FormData): Promise<any> {
    try {
      return await apiService.postFormData<IResponse>(apiValues.UPLOAD_ASSETS_ENDPOINT, formData);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }   
  /**
   * Get Countries supported
  * @returns return server response
   */
  async getSupportedCountries(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.GET_COUNTRIES_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Create Business info
   */
  async createBusiness(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.CREATE_BUSINESS_ENTITY_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }


  /**
   * Update Business Info
   */
  async updateBusiness(payload: any): Promise<any> {
    const url = `${apiValues.UPDATE_STATION_ENDPOINT}${payload.id}/`;
    delete payload.id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }


  /**
   * Create Station
   */
  async createStation(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADD_STATION_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Update Station
   */
  async updateStation(payload: any): Promise<any> {
    const url = `${apiValues.UPDATE_STATION_ENDPOINT}${payload.id}/`;
    delete payload.id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

/**
 * Get Stations
 */
async getStations(page: number, search: string, status: string, date_range?: {start_date: string; end_date: string;}): Promise<any> {
  try {
   const params: Record<string, string> = {
        page: page.toString(),
      };
      if (search) {
        params.search = search;
      }
      if (status && status.toLowerCase() !== 'all') {
        params.status = status;
      }
      if (date_range?.start_date) {
        params.start_date = date_range?.start_date;
      }
      if (date_range?.end_date) {
        params.end_date = date_range?.end_date;
      }
      const queryParams = new URLSearchParams(params).toString();
    return await apiService.get<IResponse>(`${apiValues.STATIONS_ENDPOINT}?${queryParams}`);
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}

   /**
   * Get Station By Id
   */
  async getStationById(stationId: string): Promise<any> {
    try {
    return await apiService.get<IResponse>(`${apiValues.BUSINESS_ENTITIES_ENDPOINT}${stationId}/`);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * Get Sessions
   */
 async getSessions(page: number, search: string, status: string, dateRange?: {start_date: string; end_date: string;}): Promise<any> {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {}, ...status ? { status } : {}, ...dateRange?.start_date ? { start_date: dateRange.start_date} : {}, ...dateRange?.end_date ? { end_date: dateRange.end_date } : {}
    }).toString();
    return await apiService.get<IResponse>(`${apiValues.SESSIONS_ENDPOINT}?${queryParams}`);
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}

  /**
   * Get Sessions
   */
 async getSystemUsers(page: number, search: string, user_type: string, status: string,  dateRange?: {start_date: string, end_date: string}): Promise<any> {
  try {
     const params: Record<string, string> = {
      page: page.toString(),
    };
    if (search) {
      params.search = search;
    }
    if (status && status.toLowerCase() !== 'all') {
      params.status = status;
    }
    if (user_type && user_type.toLowerCase() !== 'all') {
      params.user_type = user_type;
    }
    if (dateRange?.start_date) {
      params.start_date = dateRange.start_date;
    }
    if (dateRange?.end_date) {
      params.end_date = dateRange.end_date;
    }
    const queryParams = new URLSearchParams(params).toString();
    return await apiService.get<IResponse>(`${apiValues.GET_SYSTEM_USERS_ENDPOINT}?${queryParams}`);
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}
  /**
   * Get Sessions
   */
 async getUsers(page: number, search: string, dateRange?: {start_date: string, end_date: string}): Promise<any> {
  try {
     const params: Record<string, string> = {
      page: page.toString(),
    };
    if (search) {
      params.search = search;
    }
    if(dateRange?.start_date){
      params.start_date= dateRange.start_date;
    }
    if(dateRange?.end_date){
      params.end_date= dateRange.end_date;
    }
    const queryParams = new URLSearchParams(params).toString();
    return await apiService.get<IResponse>(`${apiValues.GET_USERS_ENDPOINT}?${queryParams}`);
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}
/**
 * Add new user 
 * @param payload 
 * @returns 
 */
  async addNewUser(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.GET_USERS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

/**
 * Update user 
 * @param payload 
 * @returns 
 */
  async updateUser(payload: any): Promise<any> {
    const url = `${apiValues.GET_USERS_ENDPOINT}${payload.id}/`;
    delete payload.id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

/**
 * Update user role
 * @param payload 
 * @returns 
 */
  async updateUserRole(payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(apiValues.UPDATE_USER_ROLE_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  
  /**
 * Update merchant user status
 * @param payload 
 * @returns 
 */
  async updateMerchantUserState(payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(apiValues.UPDATE_MERCHANT_ACCESS_STATE_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }    
  /**
 * Update systme user state
 * @param payload 
 * @returns 
 */
  async updateSystemUserState(payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(apiValues.UPDATE_USER_STATE_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Connector types
   */
  async getConnectorTypes(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.CONNECTOR_TYPES_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Entities
   */
  async getEntities(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.BUSINESS_ENTITIES_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Pending Entities
   */
  async getPendingEntities(page: number, search: string): Promise<any> {
    try {
      const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {} 
    }).toString();
    return await apiService.get<IResponse>(`${apiValues.GET_PENDING_APPROVAL_ENTITIES_ENDPOINT}?${queryParams}`);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Update Entity status
   */
  async updateEntityStatus(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.UPDATE_PENDING_ENTITY_STATUS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Create Station Chargers
   */
  async addCharger(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADD_CHARGERS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }  
  /**
   * Create Station Chargers
   */
  async activateCharger(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ACTIVATE_CHARGERS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }  
  
  /**
   * Update Charger
   */
  async updateCharger(payload: any): Promise<any> {
    const url = `${apiValues.GET_UPDATE_CHARGER_ENDPOINT}${payload.id}/`;
    delete payload.id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
    
  /**
   * Update Charger
   */
  async resetCharger(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.RESET_CHARGER_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  
  /**
   * Update Conncetor 
   */
  async updateConnector(payload: any): Promise<any> {
    const url = `${apiValues.UPDATE_CONNECTOR_ENDPOINT}${payload.connector_id}/`;
    delete payload.connector_id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Charger By Id
   */
  async getChargerDetails (chargerId: string): Promise<any> {
    try {
    return await apiService.get<IResponse>(`${apiValues.GET_UPDATE_CHARGER_ENDPOINT}${chargerId}/`);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Update station amenities
   */
  async updateStationAmenities(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.UPDATE_STATION_AMENITIES_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Station amenities
   */
  async getStationAmenities(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.STATION_AMENITIES_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Dashboard analytics
   */
  async getDashboardAnalytics(period?: {start_date: string; end_date: string;}): Promise<any> {
    try {
        const queryParams = new URLSearchParams({ ...period ? { start_date: period.start_date, end_date: period.end_date } : {} }).toString();
        const url = `${apiValues.DASHBOARD_ANALYTICS_ENDPOINT}${queryParams ? '?' + queryParams : ''}`;
        return await apiService.get<IResponse>(url);
    } catch (error: any) {
        throw new Error(handleError(error));
    }
  }

  /**
   * Get Dashboard analytics
   */
  async getPlatformConfigData(): Promise<any> {
    try {
        return await apiService.get<IResponse>(apiValues.PLATFORM_CONFIG_DATA_ENDPOINT);
    } catch (error: any) {
        throw new Error(handleError(error));
    }
}
/**
 * Get Admin Transaction payouts or history
 */
async getAdminPayouts(page: number, search: string, status?: string, sort?: string,): Promise<any> {
  try {
    // Conditionally include parameters only if they are not undefined, null, or 'all'.
    const params: Record<string, string> = {
      page: page.toString(),
    };
    if (search) {
      params.search = search;
    }
    if (status && status.toLowerCase() !== 'all') {
      params.status = status;
    }
    if (sort && sort.toLowerCase() !== 'all') {
      params.sort = sort;
    }
    const queryParams = new URLSearchParams(params).toString();

    return await apiService.get<IResponse>(`${apiValues.ADMIN_PAYOUTS_ENDPOINT}?${queryParams}`);
  
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}

/**
   * Get Transaction payouts or history
   */
  async getPayouts(page: number, search: string, status?: string, dateRange?: {start_date: string; end_date: string;}): Promise<any> {
    try{
      // Conditionally include parameters only if they are not undefined, null, or 'all'.
      const params: Record<string, string> = {
        page: page.toString(),
      };
      if (search) {
        params.search = search;
      }
      if (status && status.toLowerCase() !== 'all') {
        params.status = status;
      }
      // if (sort && sort.toLowerCase() !== 'all') {
      //   params.sort = sort;
      // }
      if (dateRange?.start_date) {
        params.start_date = dateRange?.start_date;
      }
      if (dateRange?.end_date) {
        params.end_date = dateRange?.end_date;
      }
      const queryParams = new URLSearchParams(params).toString();

      return await apiService.get<IResponse>(`${apiValues.PAYOUTS_ENDPOINT}?${queryParams}`);
    
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * request payout
   */
  async requestPayout(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.PAYOUTS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Approve payout request
   */
  async approveRequest(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.APPROVE_REQUEST_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Payout accounts/ previously used accounts for payout
   */
  async getPayoutAccounts(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.PAYOUT_ACCOUNTS_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * Get Transaction payouts or history
   */
  async getPayoutWallet(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.PAYOUT_WALLET_ENDPOINT);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * List services
   */
  async listInAppServices(page: number, search?: string): Promise<any> {
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(), ...search ? { search } : {} 
      }).toString();
      return await apiService.get<IResponse>(`${apiValues.LIST_IN_APP_SERVICES_ENDPOINT}?${queryParams}`);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * add new service
   */
  async addInAppService(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADD_UPDATE_IN_APP_SERVICE_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * update service 
   */
  async updateInAppService(payload: any): Promise<any> {
    const url = `${apiValues.ADD_UPDATE_IN_APP_SERVICE_ENDPOINT}${payload.id}/`;
    delete payload.id;
    try {
      return await apiService.put<IResponse>(url, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /***
   * update service status
   */
  async updateInAppServiceStatus(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.UPDATE_IN_APP_SERVICE_STATUS_ENDPOINT, payload);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * delete service
   */
  async deleteInAppService(serviceId: string): Promise<any> {
    try {
      return await apiService.delete<IResponse>(`${apiValues.DELETE_IN_APP_SERVICE_ENDPOINT}${serviceId}/`);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * GET system amenities
   */
  async getSystemAmenities(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.ADMINISTRATION_AMENITIES_ENDPOINT);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

  /**
   * POST system amenity
   */
  async addSystemAmenity(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADMINISTRATION_AMENITIES_ENDPOINT, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * UPDATE system amenities
   */

  async updateSystemAmenity(payload: any): Promise<any> {
    try {
      const url = `${apiValues.ADMINISTRATION_AMENITIES_ENDPOINT}${payload.id}/`;
      delete payload.id;
      return await apiService.put<IResponse>(url, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * DELETE system amenity
   */
  async deleteSystemAmenity(id: string): Promise<any> {
    try {
      return await apiService.delete<IResponse>(`${apiValues.ADMINISTRATION_AMENITIES_ENDPOINT}${id}/`); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

/**
   * GET system ConnectorType
   */
  async getSystemConnectorTypes(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.ADMINISTRATION_CONNECTOR_TYPES_ENDPOINT);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

  /**
   * POST system ConnectorType
   */
  async addSystemConnectorType(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADMINISTRATION_CONNECTOR_TYPES_ENDPOINT, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * UPDATE system ConnectorType
   */

  async updateSystemConnectorType(payload: any): Promise<any> {
    try {
      const url = `${apiValues.ADMINISTRATION_CONNECTOR_TYPES_ENDPOINT}${payload.id}/`;
      delete payload.id;
      return await apiService.put<IResponse>(url, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * DELETE system ConnectorType
   */
  async deleteSystemConnectorType(id: string): Promise<any> {
    try {
      return await apiService.delete<IResponse>(`${apiValues.ADMINISTRATION_CONNECTOR_TYPES_ENDPOINT}${id}/`); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }


  /**
   * GET system Service Type
   */
  async getSystemServiceTypes(): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.ADMINISTRATION_SERVICE_TYPES_ENDPOINT);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

  /**
   * POST system Service Type
   */
  async addSystemServiceType(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.ADMINISTRATION_SERVICE_TYPES_ENDPOINT, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * UPDATE system Service Type
   */

  async updateSystemServiceType(payload: any): Promise<any> {
    try {
      const url = `${apiValues.ADMINISTRATION_SERVICE_TYPES_ENDPOINT}${payload.id}/`;
      delete payload.id;
      return await apiService.put<IResponse>(url, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * DELETE system Service Type
   */
  async deleteSystemServiceType(id: string): Promise<any> {
    try {
      return await apiService.delete<IResponse>(`${apiValues.ADMINISTRATION_SERVICE_TYPES_ENDPOINT}${id}/`); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * GET Commission split
   */
  async updateCommissionSplit(payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(apiValues.UPDATE_COMMISSION_SPLIT_ENDPOINT, payload);
    } catch(error: any){
      throw new Error(handleError(error));
    }
  }



  /**
   * GET redeemed Coupon details
   */
  async getRedeemedCoupons(id: string): Promise<any> {
    try {
      return await apiService.get<IResponse>(apiValues.REDEEMED_COUPONS_ENDPOINT + id + '/');
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

  /**
   * GET coupons 
   */
  async getCoupons(page: number, search?: string, status?: string, dateRange?: {start_date: string; end_date: string;} ): Promise<any> {
     try {
    const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {}, ...status ? { status } : {}, ...dateRange?.start_date ? { start_date: dateRange.start_date} : {}, ...dateRange?.end_date ? { end_date: dateRange.end_date } : {}
    }).toString();
      return await apiService.get<IResponse>(`${apiValues.COUPONS_ENDPOINT}?${queryParams}`);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

  /**
   * POST Coupon
   */
  async createCoupon(payload: any): Promise<any> {
    try {
      return await apiService.post<IResponse>(apiValues.COUPONS_ENDPOINT, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
  /**
   * PUT Coupon
   */
  async updateCoupon(payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(apiValues.COUPONS_ENDPOINT, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  async updateCouponStatus(id: string, payload: any): Promise<any> {
    try {
      return await apiService.put<IResponse>(`${apiValues.COUPONS_UPDATE_STATUS_ENDPOINT}${id}/`, payload); 
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }

  /**
   * GET transactions 
   */
  async getTransactions(page: number, search?: string, status?: string, transaction_type?: string, dateRange?: {start_date: string; end_date: string;}): Promise<any> {
     try {
    const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {}, ...status ? { status } : {}, ...transaction_type ? { transaction_type } : {}, ...dateRange?.start_date ? { start_date: dateRange.start_date} : {}, ...dateRange?.end_date ? { end_date: dateRange.end_date } : {}
    }).toString();
      return await apiService.get<IResponse>(`${apiValues.TRANSACTIONS_ENDPOINT}?${queryParams}`);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

   /**
   * Get user transactions
   */
  async getUserTransactions(page: number, search?: string, status?: string, transaction_type?: string, userId?: string, dateRange?: {start_date: string; end_date: string;}): Promise<any> {
     try {
    const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {}, ...status ? { status } : {}, ...transaction_type ? { transaction_type } : {}, ...dateRange?.start_date ? { start_date: dateRange.start_date} : {}, ...dateRange?.end_date ? { end_date: dateRange.end_date } : {}
    }).toString();
      return await apiService.get<IResponse>(`${apiValues.USER_ACCOUNT_ENDPOINT}${userId}/transactions?${queryParams}`);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

    /**
   * Get User Sessions
   */
 async getUserSessions(page: number, search?: string, status?: string, userId?: string, dateRange?: {start_date: string; end_date: string;}): Promise<any> {
  try {
    const queryParams = new URLSearchParams({
      page: page.toString(), ...search ? { search } : {}, ...status ? { status } : {}, ...dateRange?.start_date ? { start_date: dateRange.start_date} : {}, ...dateRange?.end_date ? { end_date: dateRange.end_date } : {}
    }).toString();
    return await apiService.get<IResponse>(`${apiValues.USER_ACCOUNT_ENDPOINT}${userId}/charging-sessions?${queryParams}`);
  } catch (error: any) {
    throw new Error(handleError(error));
  }
}

  /**
   * Get transaction details
   */
  async getTransactionDetails(id: string): Promise<any> {
    try {
      return await apiService.get<IResponse>(`${apiValues.TRANSACTIONS_ENDPOINT}${id}/`);
    } catch (error: any){
      throw new Error(handleError(error));
    }
  }

    async getRevenueInsights(params?: { start_date?: string; end_date?: string; group_by?: string }): Promise<any> {
    try {
      const filteredParams: { [key: string]: string } = {};
      if (params?.start_date) filteredParams.start_date = params.start_date;
      if (params?.end_date) filteredParams.end_date = params.end_date;
      if (params?.group_by && params.group_by !== "") filteredParams.group_by = params.group_by;

      const queryParams = new URLSearchParams(filteredParams).toString();
      const url = `${apiValues.REVENUE_INSIGHTS_ENDPOINT}${queryParams ? '?' + queryParams : ''}`;
      return await apiService.get<IResponse>(url);
    } catch (error: any) {
      throw new Error(handleError(error));
    }
  }
}  

export const appService = new AppService();